export const SectionLabel = ({ index, children, dark = false }) => (
  <div className="flex flex-wrap items-center gap-4" data-testid={`section-label-${index.toLowerCase()}`}>
    <span className={`font-mono text-xs tracking-[0.3em] ${dark ? "text-ink/70" : "text-acid"}`}>
      {index}
    </span>
    <span className={`h-px w-10 ${dark ? "bg-ink/40" : "bg-acid/60"}`} aria-hidden="true" />
    <span
      className={`font-mono text-xs uppercase tracking-[0.2em] max-sm:mt-1 max-sm:w-full sm:tracking-[0.3em] ${
        dark ? "text-ink/70" : "text-paper/60"
      }`}
    >
      {children}
    </span>
  </div>
);
